// extracted by mini-css-extract-plugin
export default {"StaticDiffPreview":"StaticUnifiedDiffPreview-module__StaticDiffPreview__aEqrDPB","HeaderContainer":"StaticUnifiedDiffPreview-module__HeaderContainer__iTtofvm"};